import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HousingSubscription, PagedModelHousingSubscription } from '../../api/models';
import { HProductControllerService, HSubscriptionControllerService } from '../../api/services';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxPaginationModule, PaginatePipeArgs } from 'ngx-pagination';
import { Router } from '@angular/router';
import { SessionService } from '../../common/session.service';

@Component({
    selector: 'app-hsubscription-list',
    imports: [CommonModule,NgxPaginationModule],
    templateUrl: './hsubscription-list.component.html',
    styleUrl: './hsubscription-list.component.css',
    standalone: true
})
export class HsubscriptionListComponent implements OnInit {
     promoterId: number = 0;

    subscriptions: HousingSubscription[] = [];
    pageConfig:PaginatePipeArgs = {
        currentPage: 0,
        totalItems: 20,
        itemsPerPage: 20
    };


    constructor(private hsubscriptionService: HSubscriptionControllerService,private router: Router,private sessionService: SessionService) { 

    }


    ngOnInit(): void {

        const partner = this.sessionService.getSessionInfo()?.partner!!;
        if(partner && partner.id) {
            this.promoterId = partner.id;
        }
        if(this.promoterId) {
            this.loadSubscriptions(0, 20);
        }
    }
    loadSubscriptions(pageNumber: number, pageSize: number): void {
    
        this.hsubscriptionService.getByPromoter(  this.promoterId,
                { page: pageNumber, size: pageSize, sort: ['modifiedAt,desc'] }
         ).subscribe({
            next: (resp: PagedModelHousingSubscription) => {
                this.subscriptions = resp.content?? [];
                this.pageConfig = {
                    currentPage: resp.page?.number?resp.page.number+1:1 ,
                    totalItems: resp.page?.totalElements??0,
                    itemsPerPage: resp.page?.size??20
                };
            },
            error: (err: HttpErrorResponse) => {
                console.error('Error loading subscriptions:', err);
            }
        });
    }

    getStatusClass(status?: string): string {
        switch (status) {
            case 'EN_COURS':
                return 'badge bg-success';
            case 'PENDING':
                return 'badge bg-warning';
            case 'COMPLETE':
                return 'badge bg-info';
            case 'ANNULE':
                return 'badge bg-danger';
            default:
                return 'badge bg-secondary';
        }
    }

    getStatusLabel(status?: string): string {
        switch (status) {
            case 'ACTIVE':
                return 'Actif';
            case 'PENDING':
                return 'En cours';
            case 'COMPLETED':
                return 'Terminé';
            case 'CANCELLED':
                return 'Annulé';
            default:
                return 'Inconnu';
        }
    }

  

    formatDate(dateString?: string): string {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('fr-FR');
    }

    onNextPage(page: number): void {
        this.loadSubscriptions(page-1, Number(this.pageConfig.itemsPerPage));
    }
    goToCreate(): void {
        this.router.navigate(['/housing/subscriptions/add']);
    }
}